/** Seeded pseudo-random — same output in preview and export for a given seed + index. */
export function hash01(x: number, y: number, seed: number): number {
  const v = Math.sin(x * 127.1 + y * 311.7 + seed * 43758.5453) * 43758.5453;
  return v - Math.floor(v);
}

export function seededRandom(seed: number): () => number {
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export function particleSeed(effectId: string, frameIndex: number, baseSeed: number): number {
  let h = baseSeed;
  for (let i = 0; i < effectId.length; i += 1) {
    h = (h * 31 + effectId.charCodeAt(i)) % 1000003;
  }
  return h + frameIndex * 0.137;
}
